import React from 'react';
import PropTypes from 'prop-types';

import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { Text, CenteredContainer, Title } from '@nerdwallet/currency';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';

import HeroNav from './hero-nav';
import styles from './hero.module.less';

import { heroNavContent } from '../../lib/front-page-content';

const Hero = ({ content, header }) => (
  <BedrockImpression eventType="element_impression" entityName="hero_container">
    <ElementImpression
      elementDomType="section"
      elementName="Hero"
      id="hero-container"
    >
      <CenteredContainer className={styles.heroNav}>
        <section className={styles.section}>
          <div className={styles.content}>
            <Title className={styles.header} component="h1">
              {header}
            </Title>
            <div className={styles.subtitle}>
              <Text size="large">{content}</Text>
            </div>
          </div>
          <HeroNav {...heroNavContent} />
        </section>
      </CenteredContainer>
    </ElementImpression>
  </BedrockImpression>
);

Hero.propTypes = {
  content: PropTypes.string,
  header: PropTypes.string,
};

Hero.displayName = 'Hero';

export default Hero;
